@if (!isMobile) {
    <p-table 
        #dt
        [columns]="visibleColumns"
        [value]="budgetList"
        dataKey="budgetId"
        [rowHover]="true"
        [rows]="50"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10, 25, 50, 100, 200]"
        [loading]="isLoading"
        [paginator]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [filterDelay]="500"
        [size]="'large'"
        stripedRows 
        sortField="budgetName"
        selectionMode="single"    
        [globalFilterFields]='searchColumns'
        [dt]="tableDts"
        (onFilter)="onFilterChange($event)"
        [scrollable]="true"
        scrollHeight="650px"
    >

        <ng-template #caption>
            <div class="d-flex">
                @if (baService.isBaAdmin()) {
                    <p-button 
                        icon="pi pi-plus"
                        label="Add Budget" 
                        (click)="openBudgetModal()" 
                        class="pr-1"
                    />
                }

                <p-multiselect 
                    class="pl-1"
                    display="chip" 
                    [options]="availableColumns" 
                    [(ngModel)]="visibleColumns" 
                    optionLabel="header" 
                    selectedItemsLabel="Show / Hide" 
                    [style]="{ 'min-width': '100px' }" 
                    placeholder="Choose Columns" 
                    (ngModelChange)='columnChange($event)'
                />

                <p-button 
                    class="pl-1"
                    (click)="op.toggle($event)" 
                    icon="pi pi-info-circle" 
                    label="Legend" 
                    severity="help"
                />
                <p-popover #op>
                    @for (legendVm of legend; track legendVm.id) {
                        <div class='d-flex align-items-center'>
                            <div 
                                class='square' 
                                [ngStyle]="{'background-color': legendVm.colorCode}"
                            ></div>
                            <span> = {{ legendVm?.description }}</span>
                        </div>
                    }
                </p-popover>

                <p-button 
                    class="pl-1"
                    (click)="opp.toggle($event)" 
                    icon="pi pi-search" 
                    label="Filters" 
                    severity="warn"
                />
                <p-popover #opp>
                    <div>
                        <label class='for'>Fiscal Year</label>
                        <p-select 
                            [(ngModel)]="filters.fiscalYearId" 
                            [options]="filterFiscalYears" 
                            placeholder="Fiscal Year" 
                            (onChange)="
                                this.filters.fiscalYearId = $event.value;
                                getList();
                            " 
                            optionLabel="text" 
                            optionValue="value"
                            style="min-width: 14rem" 
                            [panelStyle]="{ minWidth: '16rem' }"
                        />
                        <br /><br />

                        <label class='for'>Is Active?</label>
                        <mat-button-toggle-group 
                            #isActiveFilter
                            [(ngModel)]="filters.isActive" 
                            [value]="filters.isActive"
                            (change)="
                                this.filters.isActive = $event.value; 
                                getList();
                            "
                        >
                            <mat-button-toggle 
                                class="flex-fill" 
                                [value]="true"
                            >Yes</mat-button-toggle>
                            <mat-button-toggle 
                                class="flex-fill mx-2" 
                                [value]="false"
                            >No</mat-button-toggle>
                            <mat-button-toggle 
                                class="flex-fill" 
                                value="null"
                            >All</mat-button-toggle>
                        </mat-button-toggle-group>
                    </div>
                </p-popover>

                <p-iconfield 
                    iconPosition="right" 
                    class="ml-auto"
                >  
                    <p-button 
                        icon="pi pi-external-link" 
                        label="Export" 
                        (click)="exportList()" 
                        class="pr-1"
                    />
                    <p-inputicon>
                        <i class="pi pi-search pl-2"></i>
                    </p-inputicon>
                    <input 
                        #searchValue
                        pInputText 
                        type="text" 
                        (input)="dt.filterGlobal($event.target.value, 'contains')" 
                        placeholder="Search..." 
                    />
                    <p-button 
                        class="pl-1"
                        label="Clear" 
                        [outlined]="true" 
                        icon="pi pi-filter-slash" 
                        (click)="clearFilters(dt, searchValue)" 
                    />
                </p-iconfield>            
            </div>
        </ng-template>

        <ng-template 
            #header 
            let-columns
        >
            <tr>
                @for (col of columns; track col; let i = $index) {
                    <th 
                        [pSortableColumn]="col?.canSort ? $safeNavigationMigration(col?.field) : null" 
                        [class]="col?.cellClass"
                    >
                        @if (col?.headerTooltip != "") {
                            <span 
                                container='body' 
                                class="ignoreTooltipStyle" 
                                [ngbTooltip]="$safeNavigationMigration(col?.headerTooltip)"
                            >
                                {{ col?.header }}
                                @if (col?.field == "expenditures") { <br />(B) }
                                @else if (col?.field == "availableBudget") { <br />(C) }
                                @else if (col?.field == "currentPOsValue") { <br />(D) }
                                @else if (col?.field == "pOsRemainingBalance") { <br />(E) }
                            </span>
                        } @else { 
                            {{ col?.header }} 
                            @if (col?.field == "allocatedAmt") { <br />(A) }
                        }
                        @if (col?.canSort) { <p-sortIcon [field]="$safeNavigationMigration(col?.field)" /> }
                    </th>
                }
            </tr>
        </ng-template>

        <ng-template 
            #body 
            let-row
            let-columns="columns"
        >
            <tr 
                [pSelectableRow]="row" 
                (click)="editBudget(row.budgetId)"
            >
                @for (col of columns; track col) {
                    <td 
                        [class]="col?.cellClass"
                        [ngStyle]="{'background-color': getRowColor(row)}"
                    >
                        @if (
                            col?.field == "budgetId"
                            && row.budgetId != 0
                        ) {
                            <p-button 
                                icon="pi pi-external-link"
                                (click)="
                                    $event.stopPropagation(); 
                                    navToPOs(row.budgetId);
                                " 
                                severity="info" 
                                [ngbTooltip]="'View Budget POs'"
                            />
                        } @else if (col?.field == "funds") {
                            @if (row.funds.length <= MAX_DISPLAY_FUNDS) {
                                <div>{{ row.funds.slice(0, MAX_DISPLAY_FUNDS).join(', ')}}</div>
                            } @else {
                                <button
                                    class="btn btn-outline-dark"
                                    type="button"
                                    (click)="
                                        $event.stopPropagation(); 
                                        openFunds(row.funds);
                                    "
                                >View {{ row.funds.length }} Funds</button>
                            }
                        } @else if (
                            col?.isEditableField 
                            && col?.isCurrency
                            && col?.field == "allocatedAmt"
                        ) {
                            @if (baService.isBaManager()) {
                                <input 
                                    pInputText
                                    required 
                                    type="text"
                                    [(ngModel)]="row.allocatedAmt" 
                                    (change)="saveBudget(row)"
                                    (click)="$event.stopPropagation();" 
                                    class="form-control text-right set-col-width" 
                                    pcgCurrency 
                                    inputmode="numeric" 
                                    maxlength="15"
                                />
                            } @else { {{ row.allocatedAmt | currency }} }
                        } @else if (col?.isCurrency) { {{ row[col?.field] | currency }} } 
                        @else { {{ row[col?.field] }} }
                    </td>
                }
            </tr>
        </ng-template>

        <ng-template #footer>
            <tr>
                <td 
                    colspan="3" 
                    class="text-right"
                >Totals:</td>
                <td class="text-right">{{ allocationTotal | currency }}</td>
                <td class="text-right">{{ expenituresTotal | currency }}</td>
                <td class="text-right">{{ availableBudgetTotal | currency }}</td>
                <td class="text-right">{{ currentPoValueTotal | currency }}</td>
                <td class="text-right">{{ poBalanceTotal | currency }}</td>
                <td></td>
            </tr>
        </ng-template>

        <ng-template #emptymessage>
            <tr>
                <td 
                    colspan="9" 
                    class="text-center"
                >No records found.</td>
            </tr>
        </ng-template>

    </p-table>
} @else {    
    <div class="d-flex mb-2 pl-3 pr-3">
        @if (baService.isBaAdmin()) {
            <p-button 
                icon="pi pi-plus"
                label="" 
                (click)="openBudgetModal()" 
            />
        }

        <p-button 
            class="pl-1"
            (click)="op.toggle($event)" 
            icon="pi pi-info-circle" 
            label="" 
            severity="help"
        />
        <p-popover #op>
            @for (legendVm of legend; track legendVm.id) {
                <div class='d-flex align-items-center'>
                    <div 
                        class='square' 
                        [ngStyle]="{'background-color': legendVm.colorCode}"
                    ></div>
                    <span> = {{ legendVm?.description }}</span>
                </div>
            }
        </p-popover>

        <p-button 
            class="pl-1"
            (click)="opp.toggle($event)" 
            icon="pi pi-search" 
            label="" 
            severity="warn"
        />
        <p-popover #opp>
            <div>
                <label class='for'>Fiscal Year</label>
                <p-select 
                    [(ngModel)]="filters.fiscalYearId" 
                    [options]="filterFiscalYears" 
                    placeholder="Fiscal Year" 
                    (onChange)="
                        filters.fiscalYearId = $event.value; 
                        getList();
                    " 
                    optionLabel="text" 
                    optionValue="value"
                    style="min-width: 14rem" 
                    [panelStyle]="{ minWidth: '16rem' }"
                />
                <br /><br />

                <label class='for'>Is Active?</label>
                <mat-button-toggle-group 
                    #isActiveFilter
                    [(ngModel)]="filters.isActive" 
                    [value]="filters.isActive"
                    (change)="
                        filters.isActive = $event.value; 
                        getList();
                    "
                >
                    <mat-button-toggle 
                        class="flex-fill" 
                        [value]="true"
                    >Yes</mat-button-toggle>
                    <mat-button-toggle 
                        class="flex-fill mx-2" 
                        [value]="false"
                    >No</mat-button-toggle>
                    <mat-button-toggle 
                        class="flex-fill" 
                        value="null"
                    >All</mat-button-toggle>
                </mat-button-toggle-group>
            </div>
        </p-popover>
    </div>

    @if (budgetList?.length == 0) { <div class="text-center">No Records</div> }

    @for (row of budgetList; track row) {
        <div class="mb-4 flex items-center justify-center">
            <p-card class="p-card pl-3 pr-3">
                <ng-template #header>
                    <div 
                        class="pb-2 p-card-header"
                        [ngStyle]="{'background-color': getRowColor(row)}"
                    >
                        <h3 class="text-center">{{ row.budgetName }}</h3>
                    </div>
                </ng-template>
                
                <ng-template #title>
                    <div>
                        <p-button 
                            icon="pi pi-external-link"
                            (click)="
                                $event.stopPropagation(); 
                                navToPOs(row.budgetId);
                            " 
                            severity="info"
                            label="View Budget POs"
                        />
                    </div>
                </ng-template>

                <ng-template #subtitle>
                    <div class="text-left">
                        Fiscal Year: {{ row.fiscalYearStr }}
                    </div>
                </ng-template>

                <div>
                    <div class="row pb-1">
                        <div class="col-md-6 text-left">Funds:</div>
                        <div class="col-md-6 text-right">
                            @if (row.funds.length <= MAX_DISPLAY_FUNDS) {
                                <div>{{ row.funds.slice(0, MAX_DISPLAY_FUNDS).join(', ')}}</div>
                            } @else {
                                <button
                                    class="btn btn-outline-dark"
                                    type="button"
                                    (click)="
                                        $event.stopPropagation(); 
                                        openFunds(row.funds);
                                    "
                                >View {{ row.funds.length }} Funds</button>
                            }
                        </div>
                    </div>

                    <div class="row pb-1">
                        <div class="col-md-6 text-left">Allocations (A): </div>
                        <div class="col-md-6 text-right">
                            @if (baService.isBaManager()) {
                                <input 
                                    pInputText
                                    required 
                                    type="text"
                                    [(ngModel)]="row.allocatedAmt" 
                                    (change)="saveBudget(row)"
                                    (click)="$event.stopPropagation();" 
                                    class="form-control text-right set-col-width" 
                                    pcgCurrency 
                                    inputmode="numeric" 
                                    maxlength="15"
                                />
                            } @else {
                                {{ row.allocatedAmt | currency }}
                            }
                        </div>
                    </div>

                    <div class="row pb-1">
                        <div class="col-md-6 text-left">Expenditures YTD (B): </div>
                        <div class="col-md-6 text-right">{{ row.expenditures | currency }}</div>
                    </div>

                    <div class="row pb-1">
                        <div class="col-md-6 text-left">Available Budget (C): </div>
                        <div class="col-md-6 text-right">{{ row.availableBudget | currency }}</div>
                    </div>

                    <div class="row pb-1">
                        <div class="col-md-6 text-left">POs Value (D): </div>
                        <div class="col-md-6 text-right">{{ row.currentPOsValue | currency }}</div>
                    </div>

                    <div class="row pb-1">
                        <div class="col-md-6 text-left">POs Balance (E): </div>
                        <div class="col-md-6 text-right">{{ row.pOsRemainingBalance | currency }}</div>
                    </div>

                    <div class="row pb-1">
                        <div class="col-md-6 text-left">OCA: </div>
                        <div class="col-md-6 text-right">{{ row.oca }}</div>
                    </div>

                    <div class="row pb-1">
                        <div class="col-md-6 text-left">Is Active: </div>
                        <div class="col-md-6 text-right">{{ row.isActiveStr }}</div>
                    </div>
                </div>
            </p-card>
        </div>
    }
}

<ng-template 
    #modalNewBudget 
    let-modal
>
	<form
		[formGroup]="formGroup"
		(submit)='createBudget(formGroup.value)'
    >    
		<div class="modal-header text-light d-flex bg-nav">
			<h5 class="modal-title col-md-7">New Budget</h5>
			<button 
				type="button" 
				class="close text-light" 
				aria-label="Close" 
				(click)="modal.dismiss();"
			>
				<span aria-hidden="true">&times;</span>
			</button>
		</div>

		<div class="modal-body">			
			<div class='d-flex flex-column'>
                <div class="d-flex justify-content-between">
                    <pcg-control-group label="Name">
                        <input 
                            inputAutofocus
                            type="text" 
                            class="form-control"
                            placeholder='Budget Name'
                            formControlName="budgetName"
                            maxlength="50"
                        />
                    </pcg-control-group>

                    <pcg-control-group label="Fiscal Year">
                        <pcg-select 
                            [multiple]='false' 
                            [clearable]="false"
                            [selectFirstValue]="true"
                            dataSource='select/BA_FiscalYears'
                            placeholder='Fiscal Year'                        
                            formControlName="fiscalYearId">
                        </pcg-select>
                    </pcg-control-group>
                </div>

				<button 
                    type='submit' 
                    class="btn btn-success"
                >Create</button>
			</div>
		</div>
	</form>
</ng-template>

<ng-template 
    #modalFunds 
    let-modal
>
    <div class="modal-header text-light d-flex bg-nav">
        <h5 class="modal-title col-md-7">Funds</h5>
        <button 
            type="button" 
            class="close text-light" 
            aria-label="Close" 
            (click)="modal.dismiss();"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <ul>
            @for (fund of selectedRowFunds(); track $index) {
                <li >{{ fund }}</li>
            }
        </ul>
    </div>
</ng-template>